import { useLink } from "@made-people/grease-link";
import { OldMainMenu } from "./types";
import { OldMenuLink } from "./old-menu-link";
import { useOldMenu } from "./old-menu-context";
import { useRef } from "react";
import { useTranslate } from "@made-people/grease-translations";
import { OldMenuOverlay } from "./old-menu-overlay";

export const OldDesktopMenu = ({
  data,
  bgColor,
}: {
  data: OldMainMenu;
  bgColor: string;
}) => {
  const translate = useTranslate();
  const Link = useLink();
  const { isOpen, openMenu, closeMenu } = useOldMenu();
  const menuRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    openMenu();
  };

  return (
    <>
      <div className="hidden lg:flex gap-4">
        <span
          className={`${
            bgColor === "transparent" && !isOpen ? "text-white" : "text-black"
          } hover:underline underline-offset-4 group-data-[scrolled=true]:text-black transition-colors`}
          onMouseEnter={handleMouseEnter}
        >
          {translate("OldMenu_Shop")}
        </span>
        <Link
          href="about-miss-mary"
          className={`${
            bgColor === "transparent" && !isOpen ? "text-white" : "text-black"
          } hover:underline underline-offset-4 group-data-[scrolled=true]:text-black transition-colors`}
        >
          {translate("OldMenu_About_Miss_Mary")}
        </Link>
      </div>
      {isOpen && (
        <>
          <div
            className="bg-background-page shadow-sm w-full absolute left-0 right-0 top-full hidden lg:px-6 lg:block 2xl:px-0 z-[60]"
            ref={menuRef}
            onMouseLeave={closeMenu}
          >
            <div className="max-w-component-max-w-xl box-content mx-auto py-8 flex gap-4 items-start">
              {/* First Column Desktop */}
              <div className="flex flex-col font-bold mr-16">
                {data.primaryMenu.map((item, index) => (
                  <OldMenuLink key={index} {...item} />
                ))}
              </div>

              {/* Rest of Columns Desktop */}
              {data.additionalDesktopMenu && (
                <div className="flex flex-row gap-16">
                  {data.additionalDesktopMenu.map((columns, index) => (
                    <div key={index} className="flex flex-col">
                      {columns.links.map((link, index) => (
                        <OldMenuLink key={index} {...link} />
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <OldMenuOverlay />
        </>
      )}
    </>
  );
};
